import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { LuckySpinRewards } from '@/models/userReward/lucky-spin/lucky-spin-rewards';
import { useLottiePlayer } from '@starsoft/common/hooks';
import { Button, Image, StaggerAnimation } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import { AnimatePresence, m as motion } from 'framer-motion';
import { slideInMobile } from '@/components/core/InputSearch/Modal/variants';
import { AnyAction, Dispatch } from 'redux';
import { resetLuckySpin } from '@/lib/store/lucky-spin/actions';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';

export default function LuckySpinWonBanner() {
  const { t } = useTranslation('common');
  const dispatch: Dispatch<AnyAction> = useDispatch();
  const reward: LuckySpinRewards | null = useSelector(
    (state: RootState) => state.luckSpin.prize,
  );

  const isPrizeDefined = useSelector(
    (state: RootState) => state.luckSpin.isPrizeDefined,
  );

  const { lottieAnimationRef: starsLottie } = useLottiePlayer({
    path: '/lucky-spin-1.json',
    autoplay: isPrizeDefined,
    dependecyArray: [isPrizeDefined],
  });

  const { lottieAnimationRef: backgroundLottie } = useLottiePlayer({
    path: '/lucky-spin-2.json',
    autoplay: isPrizeDefined,
    dependecyArray: [isPrizeDefined],
  });

  function onClick(): void {
    dispatch(resetLuckySpin());
  }

  return (
    <AnimatePresence mode="wait">
      {isPrizeDefined && (
        <motion.div
          variants={slideInMobile}
          initial="hidden"
          animate="visible"
          className={styles.container}
        >
          <div className={styles.container__lottie} ref={backgroundLottie} />
          <div className={styles.container__confetti} ref={starsLottie} />
          <StaggerAnimation
            direction="column"
            stagger={0.15}
            staggerDirection="up"
            className={styles.container__content}
          >
            <div className={styles.container__content__column}>
              <div className={styles.container__content__title}>
                {t('congratulations')}
              </div>
              <div className={styles.container__content__won}>
                {t('you_won')}
              </div>
              <div className={styles.container__content__coin__wrapper}>
                <Image
                  className={styles.container__content__coin__image}
                  alt={`coin-image-${reward?.coin?.name}`}
                  src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${
                    reward?.coin?.image ?? 'brl.svg'
                  }`}
                  width={30}
                  height={30}
                  secondarySkeleton
                />
                <strong className={styles.container__content__coin__label}>
                  {WalletService.maskCurrency({
                    amount: getMoneyOrAmount(reward?.amount),
                    coin: reward?.coin,
                    hideSymbol: true,
                  })}
                </strong>
              </div>
            </div>

            <Button
              onClick={onClick}
              className={styles.container__content__button}
            >
              {t('conclude_label')}
            </Button>
          </StaggerAnimation>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
